import React from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

/**
 * Top-right "Create/Add" call-to-action for the public directory pages.
 * Logged-in members go to the matching dashboard page with the create dialog
 * auto-opened (`?new=1`); guests are sent to login.
 */
export function DirectoryCreateButton({ label, to, testId }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <Button
      onClick={() => navigate(user ? to : "/login")}
      data-testid={testId}
      className="shrink-0"
    >
      <Plus className="mr-2 h-4 w-4" /> {label}
    </Button>
  );
}
